import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var VenusMars = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M176 288c61.9 0 112-50.1 112-112S237.9 64 176 64 64 114.1 64 176s50.1 112 112 112zm176-112c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9C62.1 334.1 0 262.3 0 176 0 78.8 78.8 0 176 0s176 78.8 176 176zm-80.1 184.6c19.3-10.1 36.9-23.1 52.1-38.4 20 18.5 46.7 29.8 76.1 29.8 61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3.7-21.1 2-4.9-21.5-13-41.7-24-60.2 14.3-3.8 29.4-5.8 45-5.8 37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4-20.6 20.6c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176-50.5 0-96-21.3-128.1-55.4z"
  }));
});
VenusMars.displayName = 'VenusMars';
export var VenusMarsDimensions = {
  height: 512,
  width: 640
};